export const validateRequired = (value, fieldName) => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return `O campo ${fieldName} é obrigatório.`;
  }
  return null;
};

export const validateEmail = (email) => {
  if (!email) return null;
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!re.test(String(email).toLowerCase())) {
    return 'E-mail inválido.';
  }
  return null;
};

export const validateCpfCnpj = (value) => {
  if (!value) return null;
  const cleanValue = value.replace(/\D/g, '');
  if (cleanValue.length !== 11 && cleanValue.length !== 14) {
    return 'CPF ou CNPJ inválido.';
  }
  return null;
};

export const validatePhone = (phone) => {
  if (!phone) return null;
  const cleanPhone = phone.replace(/\D/g, '');
  if (cleanPhone.length < 10 || cleanPhone.length > 11) {
    return 'Telefone inválido.';
  }
  return null;
};

export const validateCep = (cep) => {
  if (!cep) return null;
  const cleanCep = cep.replace(/\D/g, '');
  if (cleanCep.length !== 8) {
    return 'CEP inválido.';
  }
  return null;
};